
/**
 * @nullable
 */
export type CreateCourseDraft201Level = typeof CreateCourseDraft201Level[keyof typeof CreateCourseDraft201Level] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201Level = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
